import { UserType } from '../../proto';

export interface MentionMemberTextNode {
  uid: number;
  nickName: string;
}

export enum CommonLinkTextType {
  unknown,
  channelLink, // 频道跳转
  webLink, // web跳转
  botConfigLink, // 机器人配置跳转
  appLink, // app页面通转
  botWebLink, // 机器人h5页面跳转
  botConfigWithParamLink, // 机器人配置页带参数跳转
}

export interface CommonLinkTextNode {
  type: CommonLinkTextType;
  displayName: string;
  ext: Record<string, unknown>;
}

export interface ChannelLinkTextNode extends Record<string, unknown> {
  // 这里必须是number，涉及到客户端和前端的字符解析，会影响#
  gid: number;
  cid: string;
  cname: string;
}

export interface EmojiTextNode {
  symbol: string;
  path: string;
}

export interface ReportData{
  toUid: string,
  userType: UserType,
  messageId: string,
  messageType: number,
}
export interface CustomMessageBaseComponent {
  type: CustomMessageType;
  reportData?: ReportData;
  child?: CustomMessageBaseComponent;
  children?: Array<CustomMessageBaseComponent>;
  brother?: number;
  scale?: number;
  onClick?: CustomMessageClickData;
  usedWidth?: boolean;
  version?: number;
}
export interface CustomMessageMayItem {
  type: CustomMessageType;
  reportData?: ReportData;
  child?: CustomMessageBaseComponent;
  children?: Array<CustomMessageBaseComponent>;
  version?: number;
  brief?: string;
  onClick?: CustomMessageClickData;
  adaptWidth?: number;
  width?: number;
  height?: number;
  padding?: CustomMessagePadding;
  constraints?: CustomMessageConstraints;
  margin?: CustomMessageMargin;
  decoration?: CustomMessageContainerDecoration;
  content?: string;
  textAlign?: CustomMessageTextAlign;
  style?: CustomMessageTextStyle;
  maxLines?: number;
  mainAxisAlignment?: CustomMessageMainAxisAlignment;
  crossAxisAlignment?: CustomMessageCrossAxisAlignment;
  fit?: CustomMessageImageFit;
  radius?: number;
  alignment?: CustomMessageAlignment;
  left?: number;
  right?: number;
  bottom?: number;
  top?: number;
  enable?: boolean;
  text?: string;
  color?: string;
  scale?: number;
}
export interface CustomMessageRootComponent extends CustomMessageBaseComponent {
  version: number;
  brief: string;
  onClick?: CustomMessageClickData;
  adaptWidth?: number;
}

export interface CustomMessageSizedBoxComponent
  extends CustomMessageBaseComponent {
  width?: number;
  height?: number;
}

export interface CustomMessageContainerComponent
  extends CustomMessageBaseComponent {
  width?: number;
  height?: number;
  padding?: CustomMessagePadding;
  constraints?: CustomMessageConstraints;
  margin?: CustomMessageMargin;
  decoration?: CustomMessageContainerDecoration;
  alignment?: CustomMessageAlignment
}

export interface CustomMessageTextComponent extends CustomMessageBaseComponent {
  content: string;
  textAlign?: CustomMessageTextAlign;
  style?: CustomMessageTextStyle;
  maxLines?: number;
  template_data?: string;
}
export interface CustomMessageColumnComponent
  extends CustomMessageBaseComponent {
  mainAxisAlignment?: CustomMessageMainAxisAlignment;
  crossAxisAlignment?: CustomMessageCrossAxisAlignment;
}
export interface CustomMessageRowComponent extends CustomMessageBaseComponent {
  mainAxisAlignment?: CustomMessageMainAxisAlignment;
  crossAxisAlignment?: CustomMessageCrossAxisAlignment;
}
export interface RowAttr {
  mainAxisAlignment?: CustomMessageMainAxisAlignment;
  crossAxisAlignment?: CustomMessageCrossAxisAlignment;
  width?: string;
}
export interface CustomMessageImageComponent
  extends CustomMessageBaseComponent {
  width?: number;
  height?: number;
  fit?: CustomMessageImageFit;
  radius?: number;
  template_data?: string;
  url?: string
}

export interface CustomMessageStackComponent
  extends CustomMessageBaseComponent {
  alignment?: CustomMessageAlignment;
}

export interface CustomMessagePositionedComponent
  extends CustomMessageBaseComponent {
  left?: number;
  right?: number;
  bottom?: number;
  top?: number;
  width?: number;
  height?: number;
}

export interface CustomMessageConstrainedBoxComponent
  extends CustomMessageBaseComponent {
  constraints: CustomMessageConstraints;
}
export interface CustomMessageKKButtonComponent
  extends CustomMessageBaseComponent {
  width?: number;
  height?: number;
  enable?: boolean;
  padding?: CustomMessagePadding;
  style?: CustomMessageTextStyle;
  text: string;
  color?: string;
  onClick?: CustomMessageClickData;
}

export enum CustomMessageType {
  Root = 'Root',
  Container = 'Container',
  SizedBox = 'SizedBox',
  Text = 'Text',
  Column = 'Column',
  Row = 'Row',
  Image = 'Image',
  Stack = 'Stack',
  Positioned = 'Positioned',
  Expanded = 'Expanded',
  Spacer = 'Spacer',
  ConstrainedBox = 'ConstrainedBox',
  KKButton = 'KKButton',
}
export interface CustomMessageClickData {
  action: CustomMessageClickAction;
  uri?: string;
  ext?: Record<string, unknown>;
  wait?: boolean;
  params?: string;
  target?: string;
  botH5?: boolean;
  botId?: number;
  gid?: number;
}

export enum CustomMessageClickAction {
  scheme = 'scheme',
  webhook = 'webhook',
}

export enum CustomMessageAlignment {
  center = 'center',
  topLeft = 'topLeft',
  topCenter = 'topCenter',
  topRight = 'topRight',
  centerLeft = 'centerLeft',
  centerRight = 'centerRight',
  bottomLeft = 'bottomLeft',
  bottomRight = 'bottomRight',
  bottomCenter = 'bottomCenter',
}

export enum JustifyContent {
  start = 'start',
  center = 'center',
  end = 'end',
}
export enum AlignItems {
  start = 'start',
  center = 'center',
  end = 'end',
}

export function getJustifyContentFromAlignment(alignment?: CustomMessageAlignment): JustifyContent {
  if (!alignment) {
    return JustifyContent.start;
  }
  const centerArr = [
    CustomMessageAlignment.center,
    CustomMessageAlignment.topCenter,
    CustomMessageAlignment.bottomCenter,
  ];
  const leftArr = [
    CustomMessageAlignment.topLeft,
    CustomMessageAlignment.centerLeft,
    CustomMessageAlignment.bottomLeft,
  ];
  if (centerArr.find(item => item === alignment)) {
    return JustifyContent.center;
  }
  if (leftArr.find(item => item === alignment)) {
    return JustifyContent.start;
  }
  return JustifyContent.end;
}
export function getAlignItemsFromAlignment(alignment?: CustomMessageAlignment): AlignItems {
  if (!alignment) {
    return AlignItems.start;
  }
  const centerArr = [
    CustomMessageAlignment.center,
    CustomMessageAlignment.centerLeft,
    CustomMessageAlignment.centerRight,
  ];
  const leftArr = [
    CustomMessageAlignment.topLeft,
    CustomMessageAlignment.topCenter,
    CustomMessageAlignment.topRight,
  ];
  if (centerArr.find(item => item === alignment)) {
    return AlignItems.center;
  }
  if (leftArr.find(item => item === alignment)) {
    return AlignItems.start;
  }
  return AlignItems.end;
}
export enum CustomMessageImageFit {
  fill = 'fill',
  contain = 'contain',
  cover = 'cover',
  fitWidth = 'fitWidth',
  fitHeight = 'fitHeight',
  none = 'none',
  scaleDown = 'scaleDown',
}
export enum CustomMessageMainAxisAlignment {
  start = 'start',
  end = 'end',
  center = 'center',
  spaceBetween = 'spaceBetween',
  spaceAround = 'spaceAround',
  spaceEvenly = 'spaceEvenly',
}
export enum CustomMessageCrossAxisAlignment {
  start = 'start',
  end = 'end',
  center = 'center',
  stretch = 'stretch',
  baseline = 'baseline',
}
export enum CustomMessageTextAlign {
  start = 'start',
  left = 'left',
  right = 'right',
  center = 'center',
  justify = 'justify',
  end = 'end',
}
export interface CustomMessageTextStyle {
  color?: string;
  backgroundColor?: string;
  fontSize?: number;
  fontWeight?: CustomMessageFontWeight;
}
export enum CustomMessageFontWeight {
  one = 100,
  two = 200,
  three = 300,
  four = 400,
  five = 500,
  six = 600,
  seven = 700,
  eight = 800,
  nine = 900,
}
export interface CustomMessagePadding {
  left?: number;
  right?: number;
  top?: number;
  bottom?: number;
}
export interface CustomMessageMargin {
  left?: number;
  right?: number;
  top?: number;
  bottom?: number;
}
export interface CustomMessageConstraints {
  minWidth?: number;
  minHeight?: number;
  maxWidth?: number;
  maxHeight?: number;
}
export interface CustomMessageContainerDecoration {
  border?: CustomMessageContainerBorder;
  color?: string;
  image?: CustomMessageContainerImage;
  radius?: number;
}
export interface CustomMessageContainerBorder {
  width?: number;
  color?: string;
}
export interface CustomMessageContainerImage {
  url?: string;
}
export interface CustomMessageAnalysedUrl {
  protocol: string;
  path: Array<string>;
  query?: CustomMessageUrlQuery
}
export interface CustomMessageUrlQuery {
  [proppName: string]: string
}
